const _PhysicianPortalEventTypeId = Symbol();
const _name = Symbol();
const _description = Symbol();

const coalesce = (...args) => args.find(v => v !== undefined);

export class PhysicianPortalEventType {
	constructor(PhysicianPortalEventTypeId, name, description) {
		this.PhysicianPortalEventTypeId = PhysicianPortalEventTypeId;
		this.name = name;
		this.description = description;
	}
	get PhysicianPortalEventTypeId() {
		return this[_PhysicianPortalEventTypeId];
	}
	set PhysicianPortalEventTypeId(v) {
		if(!Number.isInteger(v))
			throw new TypeError('PhysicianPortalEventTypeId must be an integer.');
		this[_PhysicianPortalEventTypeId] = v;
	}
	get name() {
		return this[_name];
	}
	set name(v) {
		if(typeof v !== 'string')
			throw new TypeError('name must be a string.');
		this[_name] = v;
	}
	get description() {
		return this[_description];
	}
	set description(v) {
		if(typeof v !== 'string')
			throw new TypeError('description must be a string.');
		this[_description] = v;
	}
	toJSON() {
		return {
			PhysicianPortalEventTypeId: this.PhysicianPortalEventTypeId,
			name: this.name,
			description: this.description
		};
	}
	static fromObject(obj) {
		if(obj === null || typeof obj !== 'object')
			throw new TypeError('obj must be an object.');
		return new this(
			coalesce(obj.PhysicianPortalEventTypeId, obj.PhysicianPortalEventTypeId),
			coalesce(obj.name, obj.Name),
			coalesce(obj.description, obj.Description)
		);
	}
}